import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { CustomLink } from '../../common/CustomLink'
import useGetExchangeRates from '../../common/category/useGetExchangeRates'
import { Checkbox } from '../../common/html/checkbox'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { Image } from '../../common/image'
import currencyConversionIcon from '../../common/order/customPrice/currencyConversion.svg'
import { Tooltip } from '../../common/tooltip'
import { formatCurrency, formatCurrencyFollowLocale } from '../../helpers/value'
import { COMPONENTS } from '../../routers/constants'
import { CURRENCY } from '../../utils/currency'
import ItemInformation from '../common/ItemInformation'
import ItemsInformation from '../common/ItemsInformation'
import { LANGUAGE } from '../constant'
import { convertAvailableFSData, handleVersionReport } from '../helper'
import classes from '../index.module.scss'
import {
  TYPE_DATA_REPORT_STORE,
  TYPE_REPORT_STORE,
  changeDataReport,
  checkItem,
  selectBusinessCreditReportDetail,
  selectIsCheck,
  uncheckItem,
} from '../store/slice'
import { delCartItem } from '../store/thunk'
import { DeleteItems } from './poupAction/DeleteItems'
import { PopupChangeBusinessReport } from './poupChangeBusinessReport/PoupChangeBusinesReport'

const ItemBusinessCreditReport = ({ id, index }) => {
  const dispatch = useDispatch()

  const [isShow, setShow] = useState(false)
  const [isShowDelete, setShowDelete] = useState(false)

  const locale = useSelector((state) => state.i18n.locale)
  const { exchangeRates } = useGetExchangeRates()
  const detail = useSelector(selectBusinessCreditReportDetail(id))
  const isChecked = useSelector(selectIsCheck(id))

  const onChange = (isChecked) => {
    if (isChecked) {
      dispatch(checkItem(id))
    } else {
      dispatch(uncheckItem(id))
    }
  }

  const onCloseDelete = () => {
    setShowDelete(false)
  }

  const onOpenDelete = () => {
    setShowDelete(true)
  }

  const onSubmitDelete = () => {
    handleDelete()
  }

  const handleDelete = () => {
    dispatch(
      delCartItem({
        cartItemIds: [id],
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changeDataReport({
            path: [
              TYPE_REPORT_STORE.BUSINESS_CREDIT,
              TYPE_DATA_REPORT_STORE.IDS,
              id,
            ],
            data: false,
          }),
        )
      })
      .catch(() => {})
  }

  return (
    <>
      <Element
        style={{ borderTop: index ? '1px dashed #D5D5D5' : undefined }}
        className={`${classes.headerItem}`}
        id={id}
      >
        <div className={`${classes.column1} dFlex alignItemsStart`}>
          <Checkbox
            checked={isChecked}
            onChange={onChange}
            styleIcon={{ fontSize: 16 }}
          />
        </div>

        <Element
          style={{ color: '#0553A5' }}
          className={`fw600 ${classes.column2}`}
        >
          <CustomLink
            target="_blank"
            to={
              COMPONENTS.companyAnalysis.components.summary.route +
              '?organizationId=' +
              detail?.organizationId
            }
          >
            {detail?.companyName}
          </CustomLink>
        </Element>
        <div className={classes.column3}>
          {detail.price !== detail.subPrice && (
            <Element
              className={`fw500 ${classes.oldPrice}`}
              style={{ color: '#D5D5D5', fontSize: 14 }}
            >
              {formatCurrency(
                detail.price,
                CURRENCY.USD,
                CURRENCY.VND,
                exchangeRates,
                locale,
              )}
            </Element>
          )}

          <Element className="fw500" style={{ color: '#0553A5', fontSize: 14 }}>
            {formatCurrency(
              detail.subPrice,
              CURRENCY.USD,
              CURRENCY.VND,
              exchangeRates,
              locale,
            )}
          </Element>
          <div className="pl1 dFlex alignItemsCenter">
            <Tooltip
              tooltipContent={formatCurrencyFollowLocale(
                detail.subPrice,
                CURRENCY.USD,
                locale,
              )}
            >
              <Image
                src={currencyConversionIcon}
                alt="changeCurrency"
                style={{ width: 18, height: 18 }}
              />
            </Tooltip>
          </div>
        </div>
        <div className={classes.column4}>
          <div className="dFlex alignItemsCenter">
            <Icon
              className="icon-edit-square"
              style={{ fontSize: 18, color: '#0553A5' }}
              onClick={() => setShow(true)}
            />
            <Icon
              className="icon-trash-fill ml2"
              style={{ fontSize: 17, color: '#9C9C9C' }}
              onClick={onOpenDelete}
            />
          </div>
        </div>
      </Element>
      <ItemInformation
        title="cartAndOrders.main.reportType"
        value={detail.reportType}
      />
      <ItemInformation
        title="cartAndOrders.main.version"
        value={handleVersionReport(
          detail.version,
          detail.dateCreated,
          detail.idTypeReport,
          locale,
        )}
      />
      <ItemInformation
        title={
          !detail?.version
            ? 'cartAndOrders.main.availableData'
            : 'cartAndOrders.main.reportingYear'
        }
        value={convertAvailableFSData(detail)}
      />
      <ItemInformation
        title="cartAndOrders.main.language"
        value={
          <Translate
            value={`cartAndOrders.main.${
              detail.language === LANGUAGE.EN ? 'ENGLISH' : 'VIETNAMESE'
            }`}
          />
        }
      />
      <ItemInformation
        title="cartAndOrders.main.currency"
        value={detail.currency}
      />
      {!!detail.additionalCurrency && (
        <ItemsInformation
          data={[
            {
              title: 'cartAndOrders.main.additional',
              value: detail.additionalCurrency,
            },
          ]}
          style={{ gap: 2 }}
        />
      )}
      {isShow && (
        <PopupChangeBusinessReport
          isShow={isShow}
          onClose={() => setShow(false)}
          data={detail}
        />
      )}
      {isShowDelete && (
        <DeleteItems
          isShow={isShowDelete}
          handleClose={onCloseDelete}
          handleSubmit={onSubmitDelete}
          count={1}
        />
      )}
    </>
  )
}

export default ItemBusinessCreditReport
